// extracted by mini-css-extract-plugin
module.exports = {"modal-body":"JUMGua_OK4wVPC_4TWF_m"};